import { Box, Paper, IconButton, Divider, useMediaQuery, Typography, LinearProgress } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { AiFillHome, AiFillCaretRight } from 'react-icons/ai';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import useBreadcrumbs from 'use-react-router-breadcrumbs';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import Card from '@mui/material/Card';
import { ChevronRight } from '@mui/icons-material';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import { useDispatch, useSelector } from 'react-redux';
import { SET_MENU } from '../../store/actions';
import Cookies from 'js-cookie';
import NeedHelpButton from 'ui-components/NeedHelpButton';
import { useToast } from 'context/ToastContext';
// import ProgressBar from './ProgressBar';

const BreadcrumbHeader = ({ title, titleStyle = {}, shouldGoBack = false, breadcrumbTitle = '', Actions, customBackgroundColor, sx = {}, isDarkMode = false }) => {
    const location = useLocation().pathname;
    const routes = [
        // { path: '/', breadcrumb: 'Overview' },
        { path: '/', breadcrumb: 'Deals' },
        {
            path: 'deal-flow',
            breadcrumb: 'Deals',
            children: [
                { path: '*', breadcrumb: title },
            ],
        },
        {
            path: 'startups',
            breadcrumb: 'Startups',
            children: [
                { path: '*', breadcrumb: title },
                {
                    path: "rounds",
                    children: [
                        {
                            path: '', breadcrumb:
                                location?.includes("/startups/rounds/view")
                                    || location?.includes("/startups/rounds/round_investors")
                                    || location?.includes("/startups/rounds/documents")
                                    || location?.includes("/startups/rounds/add-round")
                                    || location?.includes("/startups/rounds/edit-round")
                                    ? breadcrumbTitle : title
                        },
                        { path: 'view', breadcrumb: title },
                        { path: 'round_investors', breadcrumb: title },
                        { path: 'documents', breadcrumb: title },
                        { path: 'edit-round', breadcrumb: title },
                        { path: 'add-round', breadcrumb: title },
                        { path: '*', breadcrumb: title }
                    ]
                },
                {
                    path: 'reports',
                    children: [
                        {
                            path: '', breadcrumb: location?.includes("/startups/reports/add-report")
                                || location?.includes("/startups/reports/edit-report")
                                ? breadcrumbTitle : title
                        }, {
                            path: 'add-report', breadcrumb: title,
                        }, {
                            path: 'edit-report', breadcrumb: title,
                        },
                        // { path: 'view', breadcrumb: null },
                        // { path: 'view/:id', breadcrumb: title },
                    ],
                },
                {
                    path: 'performance',
                    children: [
                        {
                            path: '', breadcrumb: location?.includes("/startups/performance/add-performance")
                                || location?.includes("/startups/performance/edit-performance")
                                ? breadcrumbTitle : title
                        }, {
                            path: 'add-performance', breadcrumb: title,
                        }, {
                            path: 'edit-performance', breadcrumb: title,
                        },
                        // { path: 'view', breadcrumb: null },
                        // { path: 'view/:id', breadcrumb: title },
                    ],
                },
                {
                    path: 'users',
                    children: [
                        {
                            path: '', breadcrumb: location?.includes("/startups/users/add-user")
                                || location?.includes("/startups/users/edit-user")
                                ? breadcrumbTitle : title
                        }, {
                            path: 'add-user', breadcrumb: title,
                        }, {
                            path: 'edit-user', breadcrumb: title,
                        },
                        // { path: 'view', breadcrumb: null },
                        // { path: 'view/:id', breadcrumb: title },
                    ],
                }
            ],
        },
        {
            path: 'backrr_startups',
            breadcrumb: Cookies.get("permissions") ? 'Backrr Startups' : "Startups",
            children: [
                { path: '*', breadcrumb: title },
            ],
        },
        {
            path: 'backrr_investors',
            breadcrumb: 'Backrr Investors',
            children: [
                { path: '*', breadcrumb: title },
            ],
        },
        {
            path: 'profile',
            children: [
                { path: '', breadcrumb: location?.includes("/profile/edit_profile") ? breadcrumbTitle : title },
                { path: 'edit_profile', breadcrumb: title },
            ]
        },
        {
            path: 'pitch-reels',
            children: [
                { path: '', breadcrumb: "Reels" },
                { path: 'selected', breadcrumb: null },
                { path: 'deal-flow', breadcrumb: "Pipelines" },
                { path: 'all', breadcrumb: "All" },
            ]
        },
        {
            path: 'portfolio',
            breadcrumb: "Portfolio",
            children: [
                {
                    path: 'create_portfolio',
                    breadcrumb: title,
                }
            ]
        },
        {
            path: 'reports',
            breadcrumb: 'Reports',
            children: [
                {
                    path: 'create_report', breadcrumb: 'Create Report',
                    children: [
                        { path: ':id', breadcrumb: null }, // Breadcrumb for :id will not be rendered
                    ],
                },
                { path: 'edit_report', breadcrumb: null },
                { path: 'edit_report/:id', breadcrumb: title },
                // { path: 'view', breadcrumb: null },
                // { path: 'view/:id', breadcrumb: title },
            ],
        },
        {
            path: 'settings',
            children: [
                { path: '', breadcrumb: location?.includes("/settings/add_user") ? breadcrumbTitle : title },
                { path: 'add_user', breadcrumb: title },
            ],
        },
        {
            path: 'admin_settings',
            children: [
                { path: '', breadcrumb: location?.includes("/admin_settings/add_version") || location?.includes("/admin_settings/view_version") ? breadcrumbTitle : title },
                { path: 'add_version', breadcrumb: title },
                { path: 'view_version', breadcrumb: title },
            ],
        },
        {
            path: 'tools',
            // Breadcrumb on the PARENT node so every /tools/* sub-page shows the exact
            // sidebar nav label ("Pitch Deck Analyzer") for this segment, not the
            // auto-generated "Tools". The index child below is nulled to avoid a
            // duplicate crumb at exactly /tools.
            breadcrumb: "Pitch Deck Analyzer",
            children: [
                { path: '', breadcrumb: null },
                // { path: '', breadcrumb: "Tools & Resources" },
                // Nulled rather than renamed: the parent 'tools' node above already
                // renders "Pitch Deck Analyzer", so labelling this segment too would
                // print it twice ("Pitch Deck Analyzer > Pitch Deck Analyzer > Start").
                // Same reason the index child on the line above is nulled.
                { path: 'bulk-analysis', breadcrumb: null },
                { path: 'bulk-analysis/start', breadcrumb: "Start" },
                { path: 'bulk-analysis/detail', breadcrumb: "Detail" },
                { path: 'bulk-analysis/detail/:file_id', breadcrumb: null } // :file_id hidden - no raw id in the breadcrumb
            ],
        },
        { path: '', breadcrumb: null },
                // { path: '', breadcrumb: "Tools & Resources" },
                // Must read exactly like the sidebar nav item that links here
                // (Sidebar/index.js -> "Pitch Deck Analyzer", path '/bulk-analysis').
                // It used to say "Bulk Deck Analyzer", so clicking the nav item landed
                // you on a page whose breadcrumb named something else.
                { path: 'bulk-analysis', breadcrumb: "Pitch Deck Analyzer" },
                { path: 'bulk-analysis/start', breadcrumb: "Start" },
                { path: 'bulk-analysis/detail', breadcrumb: "Detail" },
                { path: 'bulk-analysis/detail/:file_id', breadcrumb: null } // :file_id hidden - no raw id in the breadcrumb
                ,{
            path: 'orders-invoices',
            children: [
                { path: '', breadcrumb: "Orders & Invoices" },
                { path: 'one-time', breadcrumb: "One-Time Purchases" },
                { path: 'subscriptions', breadcrumb: "Subscriptions" },
            ],
        },
    ];

    if (!Actions) {
        Actions = () => <NeedHelpButton isDarkMode={isDarkMode} />
    }


    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const isMediumScreen = useMediaQuery(theme.breakpoints.between('sm', 'md'));
    const isNotLargeScreen = useMediaQuery(theme.breakpoints.down('md'));
    const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));
    const navigate = useNavigate();
    const open = useSelector((state) => state.customization.opened);
    const dispatch = useDispatch();
    const drawerToggle = () => {
        dispatch({ type: SET_MENU, opened: !open });
    };
    const { toasts, Toast, removeToast, resetToast } = useToast()

    const allBreadcrumbs = useBreadcrumbs(routes);
    // On phones only the current page's crumb is shown - the parent trail is dropped so a
    // deep path can't eat the header width (and push the Actions button off-screen).
    // Nulled crumbs (e.g. ':file_id') are filtered out first so we never collapse to a
    // crumb that renders nothing.
    const visibleBreadcrumbs = allBreadcrumbs?.filter(({ breadcrumb }) => breadcrumb);
    const breadcrumbs = isSmallScreen && visibleBreadcrumbs?.length
        ? visibleBreadcrumbs.slice(-1)
        : allBreadcrumbs;

    return (
        <>
            {/* {shouldGoBack && <IconButton sx={{backgroundColor: '#fff', boxShadow: 3}} onClick={()=>console.log(navigate(-1))}>
        <KeyboardBackspaceIcon />
      </IconButton>} */}
            <Card sx={{ position: 'relative', padding: { xs: '1rem', md: '1rem 2rem' }, boxShadow: "none", borderRadius: isNotLargeScreen ? 0 : '24px 0 0 0', background: customBackgroundColor ? customBackgroundColor : "#fffdfa", ...sx }}>
                <Box
                    sx={{
                        backgroundColor: customBackgroundColor ? customBackgroundColor : "#fffdfa",
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        flex: 1,
                        maxHeight: 30
                    }}
                    className="breadcrumb-flex-wrap"
                >
                    {/* minWidth:0 lets this shrink below its content width, so a long title
                        ellipsizes instead of shoving the Actions button past the Card's
                        overflow:hidden edge (the "buttons are getting cut" bug on mobile).
                        A flex item defaults to min-width:auto, which refuses to shrink. */}
                    <Box sx={{ display: 'flex', alignItems: 'center', minWidth: 0, overflow: 'hidden' }} className="breadcrumb-box">
                        {/* <Link to="/" style={{ textDecoration: 'none' }}>
                            <AiFillHome
                                style={{ position: 'relative', top: '2px', fontSize: '16px' }}
                                color={theme.palette.secondary[800]}
                            />
                        </Link> */}
                        {isNotLargeScreen && <IconButton sx={{ padding: 0, display: 'grid', placeItems: 'center', marginRight: 1, ...(isDarkMode ? { color: "white" } : {}) }} onClick={drawerToggle}> <MenuRoundedIcon sx={{ width: '2.5rem', height: '2.5rem', padding: "5px" }} /> </IconButton>}
                        {breadcrumbs?.map(({ match, breadcrumb, key, location }, index) => {
                            // Skip the breadcrumb if it is null (e.g., for ':id')
                            if (!breadcrumb) return null;

                            return (
                                <Box key={key}>

                                    {location.pathname !== key ? (
                                        <>
                                            {/* index 0 is the root "Deals" crumb, hidden when it isn't the
                                                current page - unless it's the only crumb left, which is the
                                                collapsed mobile case and must still render. */}
                                            {(index > 0 || breadcrumbs?.length === 1) && <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                {breadcrumbs?.length - 1 === index ? <Typography
                                                    variant='title'
                                                    sx={{
                                                        textDecoration: 'none',
                                                        fontSize: { xs: '1rem', sm: '1.25rem', md: '1.25rem' },
                                                        margin: 0,
                                                        ...(isDarkMode ? { color: "white" } : { color: theme.palette.secondary[800] }),
                                                        fontWeight: 700,
                                                        width: 'max-content'
                                                    }}
                                                >
                                                    {breadcrumb}
                                                </Typography> :
                                                    <Link
                                                        to={match.pathname}
                                                        style={{ textDecoration: 'none' }}
                                                    >
                                                        <Typography sx={{ fontSize: { xs: '1rem', sm: '1.25rem', md: '1.25rem' }, fontWeight: 700, color: (isDarkMode ? "white" : theme.palette.customColors.indigo600), width: 'max-content' }}>
                                                            {breadcrumb}
                                                        </Typography>
                                                    </Link>
                                                }
                                                {breadcrumbs?.length - 1 !== index && <ChevronRight sx={{ fontSize: '1.5rem', ...(isDarkMode ? { color: "white" } : { color: theme.palette.secondary[800] }), }}
                                                    style={{ marginTop: '4px' }}
                                                // color={theme.palette.secondary[800]}
                                                />}
                                            </Box>}
                                        </>
                                    ) : (
                                        <Typography
                                            sx={{
                                                textDecoration: 'none',
                                                fontSize: { xs: '1rem', sm: '1.25rem', md: '1.25rem' },
                                                margin: 0,
                                                ...(isDarkMode ? { color: "white" } : { color: theme.palette.secondary[800] }),
                                                fontWeight: 700,
                                                width: 'max-content',
                                                ...titleStyle
                                            }}
                                        >
                                            {breadcrumb}
                                        </Typography>
                                    )}
                                </Box>
                            )
                        })}

                    </Box>
                    {/* flexShrink:0 so the action button keeps its full width and the title
                        gives way instead - previously both sides shrank and the button was
                        clipped on narrow screens. */}
                    <Box sx={{ display: 'flex', alignItems: 'center', flexShrink: 0, position: isNotLargeScreen ? 'auto' : 'auto', bottom: isNotLargeScreen ? 'auto' : 'auto', zIndex: 3, right: '1rem' }}>
                        <Actions />
                    </Box>
                </Box>
                <Divider sx={{ marginTop: "1rem" }} />
                {/* <Box sx={{
                    // position: "relative",
                    // top: 0,
                    // left: 0,
                    // right: 0,
                    zIndex: 1000,
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
                }}>
                    {toasts?.length > 0 &&
                        <div className="toast-container">
                            <Toast
                                key={toasts[toasts?.length - 1].id}
                                message={toasts[toasts?.length - 1].message}
                                type={toasts[toasts?.length - 1].type}
                                duration={toasts[toasts?.length - 1].duration}
                                onClose={() => {
                                    // removeToast(toasts[toasts?.length - 1].id)
                                    resetToast()
                                }}
                            />
                        </div>
                    }
                </Box> */}
            </Card>
        </>
    );
};

export default BreadcrumbHeader;
